import React from 'react';
import {
  MessageBoxFunctionalLayout as WixMessageBoxLayout1,
  CustomModalLayout as WixMessageBoxLayout2,
} from '@wix/design-system';

const MessageBoxLayout1 = (config) => <WixMessageBoxLayout1 {...config} />;
const MessageBoxLayout2 = (config) => <WixMessageBoxLayout2 {...config} />;

export { MessageBoxLayout1, MessageBoxLayout2 };
